import { enableMapSet, produce } from 'immer';
import { ValidityStatus } from 'interfaces';
import { Product, ProductGroup } from 'services/catalog';
import { CatalogMap } from './Catalog.interface';

enableMapSet();

export function toggleProducts(
    currentSelection: CatalogMap,
    group: ProductGroup,
    products: Product[],
): [CatalogMap, ValidityStatus] {
    const newSelection = produce(currentSelection, (draft) => {
        draft.set(group.code, new Set());
        products.forEach(product => draft.get(group.code)?.add(product));

        if (!products.length) {
            draft.delete(group.code);
        }

        return draft;
    });

    const newValidityStatus: ValidityStatus = newSelection.size > 0
        ? 'Valid'
        : 'Invalid';

    return [ newSelection, newValidityStatus ];
}

export function getSelectionFromDefaultProductCodes(
    defaultProductCodes: ReadonlyArray<string>,
    catalog: ReadonlyArray<ProductGroup>,
): [CatalogMap, ValidityStatus] {
    const keyValuesArray: ReadonlyArray<[ string, Set<Product> ]> = catalog
        .reduce((acc: Array<ProductGroup>, group: ProductGroup) => {
            return [
                ...acc,
                {
                    ...group,
                    products: group.products.filter(product => defaultProductCodes.includes(product.codeProduit)),
                },
            ];
        }, [])
        .filter(group => group.products.length)
        .map(group => ([
            group.code,
            new Set(group.products),
        ]));

    return [ new Map(keyValuesArray), keyValuesArray.length ? 'Valid' : 'Invalid' ];
}
